module.exports = __webpack_public_path__ + "static/img/we.ca8c0d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/we.png
// module id = M+H0
// module chunks = 0